import { createFileRoute } from "@tanstack/react-router";
import { OrganizationAdminRoleDetailPage } from "./-components/role-detail-page";
import { ensureRouteQueryData } from "@/lib/route-loader";
import { parseRoleIdParams } from "@/lib/route-params";
import { getAdminOrganizationRoleGetOrganizationRoleQueryOptions } from "@/orval/admin-organization-role";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/roles_/$roleId")({
  params: {
    parse: parseRoleIdParams,
  },
  loader: ({ params, ...loaderContext }) =>
    ensureRouteQueryData(
      loaderContext,
      getAdminOrganizationRoleGetOrganizationRoleQueryOptions(params.organizationId, params.roleId),
    ),
  component: RouteComponent,
});

function RouteComponent() {
  const { roleId, organizationId } = Route.useParams();

  return <OrganizationAdminRoleDetailPage roleId={roleId} organizationId={organizationId} />;
}
